import { ActionTypes, IState, Action } from './types';

const reducer = (state: IState, action: Action): IState => {
  switch (action.type) {
    case ActionTypes.SET_VALUE: {
      const { key, value } = action.data;

      return { ...state, [key]: value };
    }

    case ActionTypes.SET_VALUES:
      return { ...state, ...action.data };

    default:
      return state;
  }
};

export default reducer;
